<div class="wrapper">
  <p>{{ message }}</p>
  <ng-content></ng-content>
  <a
    mat-raised-button
    (click)="onActionClick()"
    [href]="actionHref ? actionHref : getVoidUrl()"
    *ngIf="!disabled"
  >
    <mat-icon *ngIf="actionIcon">{{ actionIcon }}</mat-icon> {{ actionLabel }}
  </a>
</div>
